//import { useGrid } from "common";
import { useParams } from "common/components/Form/ParamsContext";
import { getProgramService } from "./programApi";

export default function useProgramList() {
  const params = useParams();
  const scope = undefined;
  const editUrl = `${
    Object.values(scope || {}).filter(v => !!v).length > 0 ? "programs/" : ""
  }`;
  const service = getProgramService(scope);

  return { ...service, params, scope, editUrl };
}
